// extracted by mini-css-extract-plugin
module.exports = {"tableCommon":"table_tableCommon__2q5Ul","sttCell":"table_sttCell__T4T2p","normalCell":"table_normalCell__OnzKE","rowTable":"table_rowTable__18wVB"};